import _ from "underscore";

import { getDefaultFieldSettings } from "metabase/actions/utils";
import type { ActionFormSettings, Parameter } from "metabase-types/api";

export const syncFieldsWithParameters = (
  settings: ActionFormSettings,
  parameters: Parameter[],
  previousParameters: Parameter[] = parameters,
): ActionFormSettings => {
  const parameterIds = parameters.map((parameter) => parameter.id);
  const fieldIds = Object.keys(settings.fields || {});
  const addedIds = _.difference(parameterIds, fieldIds);
  const removedIds = _.difference(fieldIds, parameterIds);

  // renaming a variable keeps its parameter id, so a custom display name would
  // otherwise stick to the renamed variable
  const renamedIds = parameters
    .filter((parameter) => {
      const previous = previousParameters.find(({ id }) => id === parameter.id);
      return (
        previous != null &&
        previous.name !== parameter.name &&
        !!settings.fields?.[parameter.id]?.title
      );
    })
    .map((parameter) => parameter.id);

  if (!addedIds.length && !removedIds.length && !renamedIds.length) {
    return settings;
  }

  const fields = _.omit(settings.fields, removedIds);

  return {
    ...settings,
    fields: {
      ...fields,
      ...Object.fromEntries(
        renamedIds.map((id) => [id, { ...fields[id], title: "" }]),
      ),
      ...Object.fromEntries(
        addedIds.map((id) => [id, getDefaultFieldSettings({ id })]),
      ),
    },
  };
};
